type Row = Record<string, string | number>;

/** Séparateur de clé composite (Unit Separator, n'apparaît jamais dans une valeur GA4/Ads). */
const SEP = '';

/** Clé d'appariement d'une ligne = valeurs de ses dimensions jointes par un séparateur sûr. */
export function dimensionKey(row: Row, dimensions: string[]): string {
  return dimensions.map((d) => String(row[d] ?? '')).join(SEP);
}

/**
 * Indexe des lignes par la tuple de leurs valeurs de dimensions.
 * Clé = valeurs des `dimensions` jointes par SEP (clé vide si aucune dimension).
 * Clés dupliquées : la dernière ligne l'emporte.
 */
export function indexRowsByDimensions(rows: Row[], dimensions: string[]): Map<string, Row> {
  const map = new Map<string, Row>();
  for (const row of rows) map.set(dimensionKey(row, dimensions), row);
  return map;
}

export { SEP as DIMENSION_KEY_SEP };
